import { AideAudienceStubPage } from '../../../../components/aides/AideAudienceStubPage';
import { getAideTertiaireStub } from '../../../../config/aides-tertiaire';

export default function TertiaireSuramortissementPage() {
  const aide = getAideTertiaireStub('suramortissement');
  if (!aide) return null;
  return <AideAudienceStubPage aide={aide} audienceId="tertiaire" />;
}
